import {Dispatch, SetStateAction} from 'react'
import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED = 'REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED'
export const doREQUEST_PARTICIPANT_LIST_UNSET_COMPLETED = createDoRequestAction(
  REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED,
)

export const requestParticipantListUnsetCompletedActionCreators = {
  doREQUEST_PARTICIPANT_LIST_UNSET_COMPLETED,
}
interface RequestParticipantListUnsetCompletedInput {
  type: string
  payload: {
    requestId: string
    participantIdList: string[]
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestParticipantListUnsetCompleted({
  payload,
  setRequestResult,
}: RequestParticipantListUnsetCompletedInput): SagaIterator {
  debug('saga*requestParticipantListUnsetCompleted')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        participantIdList: v.array().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {participantIdList} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/participant-list-unset-completed`,
    accessToken,
    data: {
      participantIdList,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/participant-list-unset-completed',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* ParticipantListUnsetCompletedSaga() {
  yield takeEvery(REQUEST_PARTICIPANT_LIST_UNSET_COMPLETED, requestParticipantListUnsetCompleted)
}
